import Vue from 'vue'
import Router from 'vue-router'

import BigScreen from '../pages/bigScreen'
import Enterprise from '../pages/Enterprise'
import homePage from '../pages/homePage'
import Index from '../pages/Index'
import Login from '../pages/Login'
import Designtool from '../pages/Designtool'
import Product from '../pages/Product'
import ToolRegister from '../pages/homePageAssembly/toolregister'
import Visualization from '../pages/visualization'
import Controls from '../pages/homePageAssembly/controls'
import About from '../pages/homePageAssembly/about'
import Fishe from '../components/graphically/fishe'
import ImportScreen from '../components/graphically/importScreen.vue'
import lxbigshow from '../components/graphically/longxin.vue'
import UserManage from '../components/other/userShow/index.vue'
import TrafficSignal from '../components/graphically/trafficSignal.vue'
import solarEnergyBigShow from '../components/graphically/solarEnergyBigShow.vue'
import cadShow from '../components/graphically/cadShow.vue'
import cadBigShow from '../components/graphically/CAD/index.vue'
import GcBigShow from '../components/graphically/GCBIG/index.vue'
import Nari from '../components/graphically/nari/index.vue'
import NariMain from '../components/graphically/nari/main.vue'
import demo from './demo'
import onlineChartOther from '../components/left-side/onlineCharTrendShowOther.vue'
import energyBarShowOther from '../components/timeChart/energyBarShowOther.vue'
import fishingShow from '../components/graphically/fishingShow.vue'
import screwShow from '../components/graphically/screwShow.vue'
import screwShowTwo from '../components/graphically/screwShowTwo.vue'
import visuaShow from '../components/graphically/visuaShow.vue'
import cgShow from '../components/graphically/beijingOffice.vue'

Vue.use(Router)

// 解决路由重复问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/homePage',
      name: 'homePage',
      component: homePage
    },
    {
      path: '/index',
      component: Index,
      meta: {
        requireAuth: true
      },
      children: [...demo.routes]
    },
    {
      path: '/designtool',
      name: 'Designtool',
      component: Designtool
    },
    {
      path: '/fiseh',
      name: 'Fishe',
      component: Fishe
    },
    {
      path: '/screen',
      name: 'ImportScreen',
      component: ImportScreen
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/toolRegister',
      name: 'ToolRegister',
      component: ToolRegister
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logon',
      name: 'Enterprise',
      component: Enterprise
    },
    {
      path: '/bigScreen',
      name: 'BigScreen',
      component: BigScreen
    },
    {
      path: '/controls',
      name: 'Controls',
      component: Controls
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/visualization',
      name: 'Visualization',
      component: Visualization
    },
    {
      path: '/lxbigshow',
      name: 'lxbigshow',
      component: lxbigshow
    },
    {
      path: '/UserManage',
      name: 'userManage',
      component: UserManage
    },
    {
      path: '/TrafficSignal',
      name: 'TrafficSignal',
      component: TrafficSignal
    },
    {
      path: '/solarEnergyBigShow',
      name: 'solarEnergyBigShow',
      component: solarEnergyBigShow
    },
    {
      path: '/cadShow',
      name: 'cadShow',
      component: cadShow
    },
    {
      path: '/cadBigShow',
      name: 'cadBigShow',
      component: cadBigShow
    },
    {
      path: '/GcBigShow',
      name: 'GcBigShow',
      component: GcBigShow
    },
    {
      path: '/Nari',
      name: 'NARI',
      component: Nari
    }, {
      path: '/NariMain',
      name: 'NariMain',
      component: NariMain
    },
    {
      path: '/onlineChartOther',
      name: 'onlineChartOther',
      component: onlineChartOther
    },
    {
      path: '/energyBarShowOther',
      name: 'energyBarShowOther',
      component: energyBarShowOther
    },
    {
      path: '/fishingShow',
      name: 'fishingShow',
      component: fishingShow
    },
    {
      path: '*',
      redirect: '/login'
    }
    ,
    // 上海城工
    {
      path: '/screwShow',
      name: 'screwShow',
      component: screwShow
    },
    {
      path: '/cgShow',
      name: 'cgShow',
      component: cgShow
    },
    // 上海城工
    {
      path: '/screwShowTwo',
      name: 'screwShowTwo',
      component: screwShowTwo
    },
    // 国传1M可视化
    {
      path: '/visuaShow',
      name: 'visuaShow',
      component: visuaShow
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否需要登录权限  
    if (localStorage.getItem('Authorization')) {
      // 判断是否登录
      next()
    } else {
      // 没登录则跳转到登录界面  
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js